import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "@/store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import VueCookies from "vue-cookies";
import "@/scss/vuetify-overrides.scss";
import "@/validation/rules";
import "./registerServiceWorker";

export const app = createApp(App);

app
  .use(router)
  .use(store)
  .use(vuetify)
  .use(i18n)
  .use(VueCookies, { expires: "7d" })
  .mount("#app");
